// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Icon base styles */
.icon {
  display: inline-block;
  vertical-align: middle;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Icon sizes */
.icon-small {
  width: 16px;
  height: 16px;
}

.icon-large {
  width: 24px;
  height: 24px;
}

/* Clickable icons */
.icon[onclick] {
  cursor: pointer;
} `, "",{"version":3,"sources":["webpack://./src/components/Icon/Icon.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB","sourcesContent":["/* Icon base styles */\n.icon {\n  display: inline-block;\n  vertical-align: middle;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* Icon sizes */\n.icon-small {\n  width: 16px;\n  height: 16px;\n}\n\n.icon-large {\n  width: 24px;\n  height: 24px;\n}\n\n/* Clickable icons */\n.icon[onclick] {\n  cursor: pointer;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
